import {keyframes} from 'styled-components';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const easeIn = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 100%;
  }
`;

export const easeOut = keyframes`
  0% {
    height: 100%;
  }
  100% {
    height: 0;
  }
`;

export const bounceUp = keyframes`
  0%, 20% {
    transform: translateY(0);
 }
  10% {
    transform: translateY(-0.5rem);
  }
`;

export const bounceDown = keyframes`
  0%, 20% {
    transform: translateY(0);
 }
  10% {
    transform: translateY(0.5rem);
  }
`;

export const rotate = keyframes`
  0% {
    transform: rotate(0);
 }
  100% {
    transform: rotate(360deg);
  }
`;

export const leftEaseIn = keyframes`
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
`;

export const animateStripes = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 60px 0;
  }
`;

export const fadeLoop = keyframes`
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.8;
  }
`;



// WEBPACK FOOTER //
// ./styles/keyframes/keyframes.js